export enum TagVariant {
  DEFAULT = 'default',
  COUNTER = 'counter',
  COUNTER_DEFAULT = 'counter-default',
  COUNTER_NEUTRAL = 'counter-neutral',
  GREEN = 'green',
  YELLOW = 'yellow',
  RED = 'red',
  GRAY = 'gray',
  TRANSPARENT = 'transparent',
}